export const ACCESS_CHOICES = [
  { value: 'read', label: 'Read Only' },
  { value: 'write', label: 'Read & Write' },
  { value: 'admin', label: 'Admin' },
] as const;
